import PageHero from "../components/PageHero";
import Libraries from "../components/sections/Libraries";
import CaseStudy from "../components/sections/CaseStudy";
import { CALENDLY_URL } from "../lib/site";

export default function LibrariesPage() {
  return (
    <div data-testid="libraries-page">
      <PageHero
        eyebrow="For Libraries &amp; Councils"
        accent="#FF007F"
        title={
          <>
            Activate makerspaces. Engage{" "}
            <span className="bg-[#FF007F] text-white px-2 inline-block">
              communities.
            </span>
          </>
        }
        intro="We turn underused library spaces into thriving community learning hubs — with programs, training and proven delivery."
        ctaLabel="Partner With Us"
        ctaTo={CALENDLY_URL}
        ctaExternal
        secondaryLabel="See the proof"
        secondaryTo="/case-studies"
      />
      <Libraries />
      <CaseStudy />
    </div>
  );
}
